import { CircularProgress } from '~/components/shared/CircularProgress'

function FullPageLoading() {
  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-white/40 backdrop-blur-sm">
      <CircularProgress indeterminate />
    </div>
  )
}

export default FullPageLoading
